const standaloneTypes = [
  'other',
  'consulting',
  'property_management',
];

export function isStandalone({ dealType }) {
  return standaloneTypes.includes(dealType) ;
}

export function getLocation(object) {
  const parts = [];

  if (object.state) {
    parts.push(object.state);
  }

  if (object.zip) {
    parts.push(object.zip);
  }

  if (object.city) {
    if (parts.length) {
      parts.unshift(`${object.city},`);
    } else {
      parts.unshift(object.city);
    }
  }

  return parts.join(' ');
}
